import store from 'store';
import * as actions from './actions';
import { defaultConfig } from 'src/app/app.general';

function getStoredSettings(storedSettings: object) {
  const settings = {};
  Object.keys(storedSettings).forEach((key) => {
    const item = store.get(`app.settings.${key}`);
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key];
  });
  return settings;
}

const STORED_SETTINGS = getStoredSettings({
  logo: defaultConfig.companyName,
  ...defaultConfig.settings,
});

// default settings, if not exist in localStorage
export const initialState: object = { ...STORED_SETTINGS };

export function reducer(state = initialState, action: actions.Actions): object {
  switch (action.type) {
    case actions.SET_STATE:
      // eslint-disable-next-line no-case-declarations
      const key = Object.keys(action.payload)[0];
      window.localStorage.setItem(`app.settings.${key}`, action.payload[key]);
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const getSettings = (state: any) => state;
